// Who can see a nav entry or a section tab (spec 49).
//
// One place for the rule nav.vue used to carry inline, because the section
// layout needs the same answer for its tab row: an entry with no `roles` is
// for everyone; one with `roles` is for exactly those. The role comes from the
// store's getters the way nav.vue always read it -- `isAdmin` first, because an
// admin's `user.role` is still 'admin' but the getter is the thing the rest of
// the app trusts -- and a missing store (a component mounted on its own in a
// test, or before /users/me has answered) reads as no role, which hides every
// gated entry rather than guessing.

export function currentRole(store) {
  const getters = (store && store.getters) || {};
  if (getters.isAdmin) return 'admin';
  const user = getters.user || null;
  return (user && user.role) || null;
}

export function allowedForRole(item, role) {
  if (!item || !item.roles) return true;
  return !!role && item.roles.includes(role);
}

export function visibleTabs(section, role) {
  if (!section || !Array.isArray(section.tabs)) return [];
  return section.tabs.filter(tab => allowedForRole(tab, role));
}
